module.exports = __webpack_public_path__ + "e5cc84fca1dd3756b1c4cbd97a49415e.svg";